/** @format */

import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconSecurityLockFill,
  homefieldIconSecurityLockUnlockedFill,
} from '@dsg-tech/homefield-angular-icons';

import { AuthenticationService } from '@shared/authentication/data-access';
import { Chain } from '@shared/data-access/interfaces';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'shared-favorites-components-private-shared-list',
  templateUrl: './private-shared-list.component.html',
  styleUrls: ['./private-shared-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, HmfButtonComponent, HomefieldIconLibraryModule, RouterModule],
})
export class PrivateSharedListComponent {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly chain = inject(Chain);
  private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

  constructor() {
    this.homefieldIconsLibraryService.registerIcons([
      homefieldIconSecurityLockFill,
      homefieldIconSecurityLockUnlockedFill,
    ]);
  }

  isAuthenticated = input(false);

  // redirect athletes to signin page
  async signIn(): Promise<void> {
    await firstValueFrom(
      this.authenticationService.login({
        target: this.chain.myAccountUrlAuthListSignIn,
      }),
    );
  }

  // redirect athletes to  createAccount page
  async createAccount(): Promise<void> {
    await firstValueFrom(this.authenticationService.createAccount());
  }
}
